import { render, staticRenderFns } from "./RightSecond.vue?vue&type=template&id=db2a5356&scoped=true"
import script from "./RightSecond.vue?vue&type=script&lang=js"
export * from "./RightSecond.vue?vue&type=script&lang=js"
import style0 from "./RightSecond.vue?vue&type=style&index=0&id=db2a5356&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2a5356",
  null
  
)

export default component.exports